import { Box, Typography, useTheme } from '@mui/material'
import { ExtraSmallButton, NonInteractiveTooltip } from '../../../custom'
import SettingsOutlinedIcon from '../../../../assets/icons/SettingOutlined'
import { useCallback, useMemo, useState } from 'react'
import { Security } from '../../../../proto/generated/security'
import OiSettingsDialog from './oiSettingsDialog'
import './oiChart.css'
import { createStringDateFromStamp } from '../../../../util/tradePage'
import { callColorCumulative, putColorCumulative } from '../../../multiStikeChart/styles'

interface Props {
    security: Security
    expiryName: number
    expiryMenu: {
        value: string
        label: string
    }[]
    selectedExpiry: {
        expirySeconds: string
        expiry: string
    } | undefined
    setSelectedExpiry: React.Dispatch<React.SetStateAction<{
        expirySeconds: string;
        expiry: string;
    } | undefined>>
    hoveredStrike: number
    callOi: string
    putOi: string
}

const OiChartMetaData = (props: Props) => {
    const theme = useTheme()
    const { security, expiryName, expiryMenu, selectedExpiry, setSelectedExpiry, hoveredStrike, callOi, putOi } = props
    const [dialog, setDialog] = useState(false)
    const metaDataStyles = useMemo(() => {
        return {
            borderColor: 'transparent',
            fontSize: '14px',
            width: 'fit-content',
            '&:hover': {
                borderColor: theme.palette.divider,
                background: theme.palette.background.paper
            },
            '&:hover .setting-btn': {
                visibility: 'visible !important'
            }
        }
    }, [theme])

    const onSubmitSettings = useCallback((expiry: {
        expirySeconds: string
        expiry: string
    }) => {
        setSelectedExpiry(expiry)
    }, [setSelectedExpiry])

    return <Box className="pane-meta-container font-feature-num" sx={{ pointerEvents: 'all' }}>
        <Typography className="oi-series-name" sx={{ ...metaDataStyles, display: 'flex', alignItems: 'center' }}>
            <span style={{ fontWeight: 500 }}>{security?.displayName ?? ''} <span
                style={{ fontWeight: 500 }}>OI</span> Expiry {createStringDateFromStamp(expiryName)}</span>
            <NonInteractiveTooltip placement={'top'} title={'Settings'} arrow>
                <ExtraSmallButton
                    color="inherit"
                    size="small"
                    className="setting-btn"
                    onClick={() => setDialog(true)}
                    data-event={'Oi widget Settings Clicked'}
                    style={{ visibility: 'hidden' }}
                    data-event-series-name={security?.displayName + ' ' + createStringDateFromStamp(expiryName)}
                >
                    <SettingsOutlinedIcon fontSize={'small'} color={'inherit'} />
                </ExtraSmallButton>
            </NonInteractiveTooltip>
        </Typography>
        <Typography className="oi-series-name" sx={metaDataStyles}>
            {`Strike ${hoveredStrike} C `}<span
            style={{ color: callColorCumulative, fontWeight: 500 }}>{callOi}</span> P <span
            style={{ color: putColorCumulative, fontWeight: 500 }}>{putOi}</span>
        </Typography>
        <OiSettingsDialog
            open={dialog}
            onClose={() => setDialog(false)}
            expiryMenu={expiryMenu}
            currentSelectedExpiry={selectedExpiry}
            onSubmit={onSubmitSettings}
        />
    </Box>
}

export default OiChartMetaData